import client from './client';
import { Order } from '../types';

export const createOrder = async (data: Omit<Order, 'id' | 'created_at'>): Promise<Order> => {
  const response = await client.post<Order>('/orders', data);
  return response.data;
};
